import VenueList from './VenueList';

export default VenueList;
